module.exports = __webpack_public_path__ + "static/media/orange-close.cb95ba3b.svg";